import React, { Component, PropTypes } from 'react';
import { getDataAttributes } from 'utils/utils';
import shouldPureComponentUpdate from 'react-pure-render/function';
import './BookCheckbox.scss';

export default class BookCheckbox extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onFieldChange: PropTypes.func.isRequired,
    onFieldBlur: PropTypes.func,
    isValid: PropTypes.bool,
    message: PropTypes.string,
    data: PropTypes.object,
    checked: PropTypes.bool,
  };

  static defaultProps = {
    isValid: null,
    data: {},
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  render() {
    const { label, placeholder, onFieldChange, isValid, message, data, checked } = this.props;

    return (
      <div className={`book-checkbox ${checked ? 'book-checkbox--checked' : ''} ${isValid === false ? 'book-checkbox--invalid' : ''} ${isValid ? 'book-checkbox--valid' : ''}`}>
        <label>
          <span className="book-checkbox__input-wrap">
            <input
              className="book-checkbox__input"
              type="checkbox"
              value={isValid === true ? '' : 'true'}
              onChange={onFieldChange}
              placeholder={placeholder}
              checked={checked}
              {...getDataAttributes(data)}
            />
          </span>
          <span className="book-checkbox__label">{label}</span>
          {isValid === false && !!message && <span className="book-checkbox__message">{message}</span>}
        </label>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/BookCheckbox/BookCheckbox.jsx
 **/